import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { CurrentMemberProvider } from './current-member-provider.service';

@Injectable({
  providedIn: 'root',
})
export class NotLoggedGuard implements CanActivate {

  constructor(
    private currentMemberProvider: CurrentMemberProvider,
  ) {
  }

  canActivate(): boolean {
    return this.currentMemberProvider.isAuthenticated() === false;
  }
}
